import React from 'react';
import {useIntl} from 'react-intl';
import cn from 'classnames';

import {EEventSource} from 'coreClasses/events/IEvents';

import AddToCartWrapper from 'brandComponents/AddToCartWrapper';
import ShowOrHideOnBreakpoint from 'brandComponents/Responsive/ShowOrHideOnBreakpoint';

import {IProductDetailFloatingButtonsProps} from './IProductDetailFloatingButtons';
import messages from './messages';

import styles from './ProductDetailFloatingButtons.module.scss';

const ProductDetailFloatingButtons = (
	{
		product,
		variationGroup,
		isMultiCurrency,
		isScrolled
	}: IProductDetailFloatingButtonsProps) => {
	const intl = useIntl();

	//TODO: PDP structure should be redesigned. We shouldn't have duplicates, which are hidden by styles
	return (
		<ShowOrHideOnBreakpoint query="<small">
			<div className={
				cn(
					styles['product-detail__floating-buttons'], {
						[styles['product-detail__floating-buttons__multi-currency']]: isMultiCurrency,
						[styles['product-detail__floating-buttons__wrapper-scrolled']]: isScrolled
					}
				)
			}>
				<AddToCartWrapper
					source={EEventSource.PDP}
					product={product}
					variationGroupId={variationGroup.getProductId()}
					classNames={{addToCartWrpp: styles['product-detail__floating-buttons__wrap']}}
					variant="primary"
					labels={{
						addToCart: intl.formatMessage(messages[product.isOrderable() ? 'addToCart' : 'notifyMe']),
						preOrderNow: intl.formatMessage(messages.preOrderNow),
						buyNow: intl.formatMessage(messages.buyNow),
						selectSize: intl.formatMessage(messages.selectSize),
					}}
					overrideButtonsConfigurations={{
						expressPayment: true,
					}}
				/>
			</div>
		</ShowOrHideOnBreakpoint>
	);
};

export default ProductDetailFloatingButtons;
